import { faCaretDown, faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';

import ContainerFlex from '../Containers/ContainerFlex';
import Icon from '../Icons/Icon';

const TitleWrapper = ({ children, subtitle }) => {
  return subtitle ? (
    <ContainerFlex itemsDirection="column">{children}</ContainerFlex>
  ) : (
    children
  );
};
TitleWrapper.defaultProps = {
  subtitle: '',
};
TitleWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
};

const ExpandableBlock = ({
  children,
  title,
  subtitle,
  initiallyExpanded,
  textColor,
}) => {
  const generateUUID = () =>
    `${Math.random().toString(16)}000000000`.substr(2, 8);

  const [showState, setShowState] = useState(initiallyExpanded);
  const [uuid] = useState(generateUUID);

  const id = `expandable-content-section-${uuid}`;
  const caret = showState ? faCaretDown : faCaretRight;

  const onClick = () => setShowState(!showState);
  const contentCss = `py-0 mb-2 ${showState ? '' : 'hidden'}`.trim();

  return (
    <Fragment>
      <div
        aria-expanded={showState}
        className="flex flex-row mb-2 cursor-pointer"
        id={id}
        onClick={onClick}
        onKeyDown={onClick}
        role="button"
        tabIndex="0"
      >
        <span className={`${textColor} w-4`}>
          <Icon icon={caret} />
        </span>
        <TitleWrapper subtitle={subtitle}>
          <span className={`${textColor} font-semibold`}>{title}</span>
          {subtitle && <span className="text-gray-5">{subtitle}</span>}
        </TitleWrapper>
      </div>

      <div aria-hidden={!showState} aria-labelledby={id} className={contentCss}>
        {children}
      </div>
    </Fragment>
  );
};

const acceptedColors = ['text-blue-3', 'text-black'];

ExpandableBlock.defaultProps = {
  initiallyExpanded: false,
  subtitle: '',
  textColor: 'text-black',
  title: 'Expandable section title',
};

ExpandableBlock.propTypes = {
  children: PropTypes.node.isRequired,
  initiallyExpanded: PropTypes.bool,
  subtitle: PropTypes.string,
  textColor: PropTypes.oneOf(acceptedColors),
  title: PropTypes.string,
};

export default ExpandableBlock;
